<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Manage datasets</h1>
                </div>
                <div class="col-lg-5 col-sm-6 text-right">
                    <button @click="handleCreateDatasetCommandV1" class="btn btn-success">Create dataset</button>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <div v-for="d in datasets" :key="d.DatasetId">
                <a :href="`/#/admin/integrations/datasets/details/${d.DatasetId}`">{{d.Name}}</a>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { computed, ref, reactive, watch, onMounted } from 'vue'
    import { guid } from '@common/Guid'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminManageDatasetsPage } from '@Integrations/Datasets/pages-core'

    document.title = "Manage datasets"

    const tid = useOrganizationUnitId()

    const { useCurrentUserQuery, useDatasetsOfOrganizationQuery, useCreateDatasetCommand } = useAdminManageDatasetsPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { modelDatasetsOfOrganizationQueryV1, runDatasetsOfOrganizationQueryV1 } = useDatasetsOfOrganizationQuery(tid)
    const datasets = computed(() => modelDatasetsOfOrganizationQueryV1.value?.Datasets || [])

    const { invokeCreateDatasetCommandV1, succeedCreateDatasetCommandV1 } = useCreateDatasetCommand(() => guid(), tid, userId, null)

    onMounted(() => {
        runCurrentUserQueryV1()
        runDatasetsOfOrganizationQueryV1()
    })

    watch(succeedCreateDatasetCommandV1, () => runDatasetsOfOrganizationQueryV1())

    function handleCreateDatasetCommandV1() {
        const name = prompt('Enter a new dataset name')
        if (name) { invokeCreateDatasetCommandV1({ Name: name }) }
    }
</script>
